/* eslint-disable prefer-const */
import _ from 'lodash';
import { WoodOutlined } from './ModelElements/WoodOutlined';
import { Insulation } from './ModelElements/Insulation';

export default function getJDLayerModel(order, sequenceCheckRule) {
  const lamellas = [];

  const olayer = _.get(order, 'layers[0]', []);

  // console.log('### sequenceCheckRule: ', sequenceCheckRule);

  const sequenceLam = olayer.orientation === 6 ? calculateLengthOffsetSequence(olayer) : calculateWidthOffsetSequence(olayer);
  // console.log('sequenceLam: ', sequenceLam);
  // if (j > 0) return;
  for (let i = 0; i < olayer.numOfLamellas; i++) {
    //   const position = [
    //     olayer.orientation === 2 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
    //     2,
    //     olayer.orientation === 1 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
    //   ];
    //   const rotation = olayer.orientation === 2 ? Math.PI / 2 : 0;

    const orientate = parseInt(olayer.orientation);
    // console.log('DEBUG orientate: ', orientate);
    switch (orientate) {
      case 4:
        if (sequenceLam[i]) {
          lamellas.push({
            component: WoodOutlined,
            scale: [olayer.lamellaWidth / 200, olayer.lamellaThickness / 100, olayer.lamellaLength / 200],
            position: [
              orientate === 4 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
              2,
              orientate === 1 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
            ],
            rotation: orientate === 4 ? Math.PI / 2 : 0,
            key: `lamella-${i}`,
            countAsOne: true
          });
        } else {
          lamellas.push({
            component: Insulation,
            scale: [olayer.lamellaWidth / 200, olayer.lamellaThickness / 100, olayer.lamellaLength / 200],
            position: [
              orientate === 4 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
              2,
              orientate === 1 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
            ],
            rotation: orientate === 4 ? Math.PI / 2 : 0,
            // eslint-disable-next-line no-undef
            key: `insulation-${j}-${i}`,
            countAsOne: true
          });
        }
        break;
      case 5:
        if (sequenceLam[i]) {
          lamellas.push({
            component: WoodOutlined,
            scale: [olayer.lamellaWidth / 200, olayer.lamellaThickness / 100, olayer.lamellaLength / 200],
            position: [
              orientate === 2 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
              2,
              orientate === 5 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
            ],
            rotation: orientate === 2 ? Math.PI / 2 : 0,
            key: `lamella-${i}`,
            countAsOne: true
          });
        } else {
          lamellas.push({
            component: Insulation,
            scale: [olayer.lamellaWidth / 200, olayer.lamellaThickness / 100, olayer.lamellaLength / 200],
            position: [
              orientate === 2 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
              2,
              orientate === 5 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
            ],
            rotation: orientate === 2 ? Math.PI / 2 : 0,
            key: `insulation-${i}`,
            countAsOne: true
          });
        }
        break;
      case 6:
      case 7: {
        if (i > 0) break;

        const panelLength = Number(olayer.panelLength || order.panelLength || olayer.lamellaLength || 0);

        const panelWidth = Number(olayer.panelWidth || order.panelWidth || 0);

        const thickness = Number(olayer.lamellaThickness || olayer.rawThickness || 40);

        const lengthOffsets = Array.isArray(olayer.lengthoffset) ? olayer.lengthoffset : [];

        const widthOffsets = Array.isArray(olayer.widthoffset) ? olayer.widthoffset : [];

        /*
         * LL / lengthoffset / horizontal ribs
         * position is along panel length
         * member spans panel width
         */
        lengthOffsets.forEach((o, m) => {
          const offset = Number(o.offset || 0);
          const ribWidth = Number(o.width || 0);

          if (ribWidth <= 0) return;

          lamellas.push({
            component: WoodOutlined,
            scale: [ribWidth / 200, thickness / 100, panelWidth / 200],
            position: [offset / 100 + ribWidth / 200 - panelLength / 200, 2, 0],
            rotation: 0,
            key: `clever-ll-${i}-${m}`,
            countAsOne: false
          });
        });

        /*
         * CL / widthoffset / vertical ribs
         * position is along panel width
         * member spans panel length
         */
        widthOffsets.forEach((o, m) => {
          const offset = Number(o.offset || 0);
          const ribWidth = Number(o.width || 0);

          if (ribWidth <= 0) return;

          lamellas.push({
            component: WoodOutlined,
            scale: [panelLength / 200, thickness / 100, ribWidth / 200],
            position: [0, 2.05, offset / 100 + ribWidth / 200 - panelWidth / 200],
            rotation: 0,
            key: `clever-cl-${i}-${m}`,
            countAsOne: false
          });
        });

        break;
      }

      default:
        lamellas.push({
          component: WoodOutlined,
          scale: [olayer.lamellaWidth / 200, olayer.lamellaThickness / 100, olayer.lamellaLength / 200],
          position: [
            orientate === 2 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1),
            2,
            orientate === 1 ? 0 : i * (olayer.lamellaWidth / 200) * 2 - (olayer.lamellaWidth / 200) * (olayer.numOfLamellas - 1)
          ],
          rotation: orientate === 2 ? Math.PI / 2 : 0,
          key: `lamella-${i}`,
          countAsOne: true
        });
    }
  }

  /* Going through again to check sequence status */
  if (Array.isArray(sequenceCheckRule)) {
    for (let i = 0; i < olayer.numOfLamellas; i++) {
      if (!lamellas[i]) continue;

      for (let j = 0; j < sequenceCheckRule.length; j++) {
        const rule = sequenceCheckRule[j];

        const value = _.get(order, `${rule.key}[${i}].${rule.value}`, true);

        if (!value && rule.component) {
          lamellas[i].component = rule.component;
        }
      }
    }
  }

  return lamellas;
}

function calculateWidthOffsetSequence(l) {
  if (l !== null) {
    let lamellas = [];
    let lastOffset = 0;
    if (l.widthoffset != undefined) {
      var sortedWidthOffset = l.widthoffset.slice().sort((a, b) => a.offset - b.offset);

      if (sortedWidthOffset.length > 0 && l.lamellaWidth > 0) {
        for (let i = 0; i < sortedWidthOffset.length; i++) {
          let ins = sortedWidthOffset[i];
          let woodWidth = ins.offset - lastOffset;
          let woodLamellas = Math.round(woodWidth / l.lamellaWidth);
          let widthoffsetLamellas = Math.round(ins.width / l.lamellaWidth);

          lastOffset = ins.offset + ins.width;
          for (let j = 0; j < woodLamellas; j++) lamellas.push(true);
          for (let j = 0; j < widthoffsetLamellas; j++) lamellas.push(false);
        }
      }
    }

    if (l.lamellaWidth > 0) {
      let endDimension = l.orientation === 4 || l.orientation === 2 ? l.panelLength : l.panelWidth;
      let woodLamellas = Math.round((endDimension - lastOffset) / l.lamellaWidth);
      for (let j = 0; j < woodLamellas; j++) lamellas.push(true);
    }

    return lamellas;
  }
}

function calculateLengthOffsetSequence(l) {
  if (l !== null) {
    let lamellas = [];
    let lastOffset = 0;
    if (l.widthoffset != undefined) {
      var sortedWidthOffset = l.widthoffset.slice().sort((a, b) => a.offset - b.offset);

      if (sortedWidthOffset.length > 0 && l.lengthoffsetWidth > 0) {
        for (let i = 0; i < sortedWidthOffset.length; i++) {
          let ins = sortedWidthOffset[i];
          let woodWidth = ins.offset - lastOffset;
          let woodLamellas = Math.round(woodWidth / l.lengthoffsetWidth);
          let widthoffsetLamellas = Math.round(ins.width / l.lengthoffsetWidth);

          lastOffset = ins.offset + ins.width;
          for (let j = 0; j < woodLamellas; j++) lamellas.push(true);
          for (let j = 0; j < widthoffsetLamellas; j++) lamellas.push(false);
        }
      }
    }

    if (l.lamellaWidth > 0) {
      let endDimension = l.orientation === 4 || l.orientation === 2 ? l.panelLength : l.panelWidth;
      let woodLamellas = Math.round((endDimension - lastOffset) / l.lamellaWidth);
      for (let j = 0; j < woodLamellas; j++) lamellas.push(true);
    }

    return lamellas;
  }
}
